import { render, staticRenderFns } from "./iconPolice.vue?vue&type=template&id=6cb6a6c8&"
import script from "./iconPolice.vue?vue&type=script&lang=js&"
export * from "./iconPolice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports